import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';

import { Checkbox } from 'office-ui-fabric-react/lib/Checkbox';
import {
  MessageBar,
  MessageBarType,
} from 'office-ui-fabric-react/lib/MessageBar';

@inject('app')
@observer
export default class Documents extends Component {
  handleChangeBool = (id) => (ev, checked) => {
    const { onSelectionChanged } = this.props;
    if (onSelectionChanged) onSelectionChanged(id, checked);
  };

  render() {
    const { documents, t } = this.props;

    return (
      <React.Fragment>
        <ul style={{ listStyle: 'none', padding: 0 }}>
          {documents.map((doc) => (
            <li key={doc.id}>
              <Checkbox
                label={`${doc.title} (${doc.fileName})${
                  doc.type ? ', ' + t(`documenttype::${doc.type}`) : ''
                }`}
                name={`document_${doc.id}`}
                checked={doc._selected}
                onChange={this.handleChangeBool(doc.id)}
                disabled={doc._disabled}
              />
              {doc._error && (
                <div
                  style={{
                    padding: '5px 0 10px 28px',
                    color: 'rgb(168, 0, 0)',
                    fontSize: 'smaller',
                  }}
                >
                  <span>{doc._error}</span>
                </div>
              )}
            </li>
          ))}
        </ul>
        {documents.filter((d) => d._disabled).length > 0 && (
          <MessageBar messageBarType={MessageBarType.warning}>
            {t('Allowed file formats')}
          </MessageBar>
        )}
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/containers/Search/Documents.jsx